function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clipEmfPath1"
}, React.createElement("path", {
  d: "m0.32013 0.48019h41.937v41.777h-41.937z"
})));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m0.59568 20.074c0-10.767 8.7071-19.513 19.435-19.513 10.748 0 19.435 8.746 19.435 19.513 0 10.787-8.6877 19.513-19.435 19.513-10.728 0-19.435-8.7265-19.435-19.513z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(.97139 0 0 .97139 -.57045 -.60537)",
  d: "m1.2005 21.288c0-11.084 8.9636-20.088 20.008-20.088 11.064 0 20.008 9.0036 20.008 20.088 0 11.104-8.9436 20.088-20.008 20.088-11.044 0-20.008-8.9836-20.008-20.088",
  clipPath: "url(#clipEmfPath1)",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 1.0295
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  className: "icon-primary",
  d: "m7.5453 30.06c0 1.3086 1.0608 2.3694 2.3694 2.3694h22.261c1.3086 0 2.3694-1.0608 2.3694-2.3694v-16.261c0-1.3086-1.0608-2.3694-2.3694-2.3694h-22.261c-1.3086 0-2.3694 1.0608-2.3694 2.3694z",
  fill: "#ecaec6",
  strokeMiterlimit: 10,
  strokeWidth: 0.33333
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m7.4725 30.085c0 1.3086 1.0608 2.3694 2.3694 2.3694h22.261c1.3086 0 2.3694-1.0608 2.3694-2.3694v-16.261c0-1.3086-1.0608-2.3694-2.3694-2.3694h-22.261c-1.3086 0-2.3694 1.0608-2.3694 2.3694z",
  fill: "none",
  strokeMiterlimit: 9
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m5.5453 27.06c0 1.3086 1.0608 2.3694 2.3694 2.3694h21.261c1.3086 0 2.3694-1.0608 2.3694-2.3694v-16.261c0-1.3086-1.0608-2.3694-2.3694-2.3694h-21.261c-1.3086 0-2.3694 1.0608-2.3694 2.3694z",
  fill: "#adb9ca",
  strokeMiterlimit: 10,
  strokeWidth: 0.33333
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m5.4185 27.138c0 1.3086 1.0608 2.3694 2.3694 2.3694h21.261c1.3086 0 2.3694-1.0608 2.3694-2.3694v-16.261c0-1.3086-1.0608-2.3694-2.3694-2.3694h-21.261c-1.3086 0-2.3694 1.0608-2.3694 2.3694z",
  fill: "none",
  strokeMiterlimit: 9
}));
var _ref7 = /*#__PURE__*/React.createElement("g", null, React.createElement("g", {
  className: "icon-tertiary",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeMiterlimit: 9
}, React.createElement("path", {
  d: "m15.545 11.263c0-0.46 0.373-0.833 0.833-0.833h4.334c0.46 0 0.833 0.373 0.833 0.833v3.334c0 0.46-0.373 0.833-0.833 0.833h-4.334c-0.46 0-0.833-0.373-0.833-0.833z",
  fill: "#fff"
}), React.createElement("path", {
  d: "m18.545 15.43v5.415",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "m10.545 21.287v-2.857h16v3",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("g", {
  fill: "#fff"
}, React.createElement("path", {
  d: "m7.5453 22.263c0-0.46 0.373-0.833 0.833-0.833h4.334c0.46 0 0.833 0.373 0.833 0.833v3.334c0 0.46-0.373 0.833-0.833 0.833h-4.334c-0.46 0-0.833-0.373-0.833-0.833z"
}), React.createElement("path", {
  d: "m15.545 22.263c0-0.46 0.373-0.833 0.833-0.833h4.334c0.46 0 0.833 0.373 0.833 0.833v3.334c0 0.46-0.373 0.833-0.833 0.833h-4.334c-0.46 0-0.833-0.373-0.833-0.833z"
}), React.createElement("path", {
  d: "m23.545 22.263c0-0.46 0.373-0.833 0.833-0.833h4.334c0.46 0 0.833 0.373 0.833 0.833v3.334c0 0.46-0.373 0.833-0.833 0.833h-4.334c-0.46 0-0.833-0.373-0.833-0.833z"
}))));
var SvgOrgStructureVirtual = function SvgOrgStructureVirtual(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOrgStructureVirtual, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Org-Structure-Virtual.c1261f3b.svg";
export { ForwardRef as ReactComponent };